(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-links"] && !Shopify.designMode) return;
  try {
    
  class CatlinksSection extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('[data-catlinks-media]');
      if (!this.media) return;

      this.images = this.media.querySelectorAll('img');
      if (this.images.length < 2) return;

      this.defaultImage = this.media.querySelector('img[data-default]');

      this.querySelectorAll('.catlinks__link').forEach((link) => {
        const target = this.media.querySelector(`img[data-block-image="${link.dataset.blockId}"]`);
        if (!target) return;

        const show = () => this.activate(target);
        const reset = () => this.activate(this.defaultImage);

        link.addEventListener('mouseenter', show);
        link.addEventListener('focus', show);
        link.addEventListener('mouseleave', reset);
        link.addEventListener('blur', reset);
      });
    }

    activate(image) {
      if (!image) return;
      this.images.forEach((img) => img.classList.toggle('is-active', img === image));
    }
  }

  if (!customElements.get('catlinks-section')) {
    customElements.define('catlinks-section', CatlinksSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
  class OdnCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.odn-carousel__track');
      this.arrows = this.querySelectorAll('.odn-carousel__arrow');
      if (!this.track) return;

      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => this.scrollByPage(btn.dataset.dir === 'next' ? 1 : -1));
      });

      this.onScroll = this.updateArrows.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByPage(direction) {
      const slide = this.querySelector('.odn-carousel__slide');
      if (!slide) return;
      const step = slide.getBoundingClientRect().width + this.gap();
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap || 0) || 0;
    }

    updateArrows() {
      if (!this.arrows.length) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.arrows.forEach((btn) => {
        if (btn.dataset.dir === 'prev') {
          btn.disabled = this.track.scrollLeft <= 2;
        } else {
          btn.disabled = this.track.scrollLeft >= max;
        }
      });
    }
  }

  if (!customElements.get('odn-carousel')) {
    customElements.define('odn-carousel', OdnCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProdCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pcar__track');
      this.arrows = this.querySelectorAll('.pcar__arrow');
      if (!this.track) return;

      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => this.scrollByPage(btn.dataset.dir === 'next' ? 1 : -1));
      });

      this.hasMoved = false;
      this.animating = false;
      this.loop = this.dataset.loop === 'true';
      if (this.loop) this.setupLoop();

      this.onScroll = this.handleScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.updateArrows();

      this.setupAutoplay();
    }

    // Clone the whole set of slides once. The track then holds two identical
    // halves, so when the user reaches the end of the first half we can jump
    // back by exactly half the scroll width with no animation — visually
    // identical, but now there is content ahead again. Infinite in both
    // directions, with no gap or rewind.
    setupLoop() {
      const slides = Array.from(this.track.children);
      if (!slides.length) return;

      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.clone = 'true';
        // ids must stay unique in the document
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        this.track.appendChild(clone);
      });

      this.halfWidth = () => this.track.scrollWidth / 2;
    }

    handleScroll() {
      this.updateArrows();
      if (!this.loop) return;

      // Never wrap while a smooth scroll is still running — resetting
      // scrollLeft mid-animation makes the browser fight its own tween,
      // which is what produced the stutter. Wait until motion has settled.
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.wrap(), 160);
    }

    wrap() {
      if (this.animating || !this.halfWidth) return;

      const half = this.halfWidth();
      if (!half) return;

      if (this.track.scrollLeft >= half) {
        this.jumpTo(this.track.scrollLeft - half);
      } else if (this.track.scrollLeft < 1 && this.hasMoved) {
        // only wrap backwards if the user actually scrolled back past the
        // start — not on first paint, where scrollLeft is legitimately 0
        this.jumpTo(half);
      }
    }

    jumpTo(left) {
      const previous = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      // force the browser to apply the jump before smooth is restored
      void this.track.offsetWidth;
      this.track.style.scrollBehavior = previous || '';
    }

    scrollByPage(direction) {
      const slide = this.querySelector('.pcar__slide');
      if (!slide) return;

      this.hasMoved = true;
      const step = slide.getBoundingClientRect().width + this.gap();

      if (this.loop && this.halfWidth) {
        const half = this.halfWidth();
        const next = this.track.scrollLeft + step * direction;

        // Rewind BEFORE animating, never during. The visible frame is
        // identical either way, so the jump is invisible, and the smooth
        // scroll that follows runs uninterrupted.
        if (next >= half) {
          this.jumpTo(this.track.scrollLeft - half);
        } else if (next < 0) {
          this.jumpTo(this.track.scrollLeft + half);
        }
      }

      this.animating = true;
      clearTimeout(this.animateTimer);
      this.animateTimer = setTimeout(() => {
        this.animating = false;
      }, 600);

      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    setupAutoplay() {
      this.interval = parseInt(this.dataset.autoplay, 10) || 0;
      if (!this.interval) return;

      // don't auto-scroll for people who asked for reduced motion
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // pause while the user is interacting or the tab is hidden
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
      this.track.addEventListener('touchstart', () => {
        this.hasMoved = true;
        this.stopAutoplay();
      }, { passive: true });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });

      this.startAutoplay();
    }

    startAutoplay() {
      if (!this.interval || this.timer) return;
      this.timer = setInterval(() => this.advance(), this.interval);
    }

    stopAutoplay() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    advance() {
      if (this.loop) {
        // scrollByPage handles the seam before animating
        this.scrollByPage(1);
        return;
      }

      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.track.scrollLeft >= max) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.scrollByPage(1);
      }
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap || 0) || 0;
    }

    updateArrows() {
      if (!this.arrows.length) return;

      if (this.loop) {
        // there is always more in both directions
        this.arrows.forEach((btn) => (btn.disabled = false));
        return;
      }

      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.arrows.forEach((btn) => {
        if (btn.dataset.dir === 'prev') {
          btn.disabled = this.track.scrollLeft <= 2;
        } else {
          btn.disabled = this.track.scrollLeft >= max;
        }
      });
    }
  }

  if (!customElements.get('prod-carousel')) {
    customElements.define('prod-carousel', ProdCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
